import type { ChatMessage } from '@/types/brain'

interface MessageBubbleProps {
  message: ChatMessage
}

export function MessageBubble({ message }: MessageBubbleProps) {
  if (message.role === 'system') {
    return (
      <div className="text-center font-swiss-mono text-swiss-caption text-swiss-gray-500 py-2">
        {message.content}
      </div>
    )
  }

  const isUser = message.role === 'user'

  return (
    <div className={`flex px-4 py-1 ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={[
          'px-4 py-3 max-w-[70%] text-swiss-body font-swiss-sans',
          isUser
            ? 'bg-swiss-black text-swiss-white'
            : 'bg-swiss-off-white border border-swiss-gray-200 text-swiss-black whitespace-pre-wrap',
        ].join(' ')}
      >
        {/* Tool use badges */}
        {!isUser && message.toolUse && message.toolUse.length > 0 && (
          <div className="mb-2 flex flex-wrap gap-1.5">
            {message.toolUse.map((tool, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-1 px-2 py-0.5 border border-swiss-gray-200 font-swiss-mono text-swiss-caption text-swiss-gray-500"
              >
                <span
                  className={`w-1.5 h-1.5 rounded-full ${
                    tool.status === 'running' ? 'bg-swiss-green' : 'bg-swiss-gray-300'
                  }`}
                />
                {tool.name}
              </span>
            ))}
          </div>
        )}

        {/* Message content */}
        <span className={isUser ? '' : 'break-words'}>{message.content}</span>
      </div>
    </div>
  )
}
